import { jsx as _jsx } from "react/jsx-runtime";
import AnchorLink from '@helsenorge/designsystem-react/components/AnchorLink';
const Link = ({ value, children }) => value ? (_jsx(AnchorLink, { href: value.href, target: value.target, children: children })) : null;
export default Link;
